const authorizedEmails = {
  productionUsers: ['deebarizo@yahoo.com'],
  developmentUsers: ['deebarizo@gmail.com', 'seekingsomething121@gmail.com']
};

export default authorizedEmails;
